<template>
	<div class="container">
		<div class="main">
			<div class="main-nav">
				<div class="main-nav-list">
					<div class="main-nav-title">
						<span></span>
						<h3>消息中心</h3>
					</div>
					<ul>
						<li :class="[activePath=='/commentReply'?'active':'']">
							<router-link to="/commentReply">评论与回复<span v-if="numberComment && numberComment != 0" class="box-circle">{{numberComment}}</span></router-link>
						</li>
						<li :class="[activePath=='/systemMessage'?'active':'']">
							<router-link to="/systemMessage">系统消息<span v-if="numberSyetem && numberSyetem != 0" class="box-circle">{{numberSyetem}}</span></router-link>
						</li>
						<li :class="[activePath=='/likeFllow'?'active':'']">
							<router-link to="/likeFllow">点赞&关注<span v-if="numberLike && numberLike != 0" class="box-circle">{{numberLike}}</span></router-link>
						</li>
					</ul>
				</div>
				
			</div>
			<div class="content">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'message',
		components: {
			
		},
		data(){
			return {
				userId: '',
				activePath: '/commentReply',
				numberComment: 0,
				numberSyetem: 0,
				numberLike: 0
			}
		},
		watch: {
			$route(to) {
				let path = to.path
				this.activePath = path
				this.getNumber()
			}
		},
		created(){
			this.activePath = this.$route.fullPath
			this.userId = localStorage.getItem('userId')||''
			this.getNumber()
		},
		methods: {
			async getNumber() {
				let param = {
					userId:  this.userId
				}
				ajaxParam(param)
				const res = await post('v1/message/getMessageUnreadCount', qs.stringify(param))
				if(res.data.code==200){
					let obj = res.data.entity
					this.numberComment = Number(obj.replyCount)
					this.numberSyetem = Number(obj.systemCount)
					this.numberLike = Number(obj.likeCount)
					console.log(this.numberComment)
				} else {
					this.$message.error(res.data.msg)
				}
			}
				
		}
	}
</script>

<style lang="less" scoped>
	.main{
		display: flex;
		width: 1200px;
		margin: 20px auto;
		padding: 20px;
		box-sizing: border-box;
		.main-nav{
			.main-nav-list{
				.main-nav-title{
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					h3{
						font-size: 16px;
						font-weight: bold;
					}
					span{
						width: 4px;
						height: 18px;
						margin-right: 4px;
						background: #DD0515;
						border-radius: 2px;
						content: ' ';
						display: block;
					}
				}
			}
			ul{
				padding-top: 2px;
				li{
					width: 138px;
					height: 28px;
					margin-top: 10px;
					margin-right: 30px;
					padding-left: 15px;
					font-size: 16px;
					color: var(--color-text-opacity);
					line-height: 28px;
					box-sizing: border-box;
					position: relative;
					border-radius: 6px;
					.box-circle{
						display: inline-block;
						font-size: 12px;
						background: var(--color-text-a);
						position: absolute;
						width: 16px;;
						height: 16px;
						line-height: 16px;
						right: 10px;
						top:50%;
						margin-top: -8px;
						text-align: center;
						border-radius: 50%;
						color: #fff;
					}
					a{
						display: block;
					}
					a:hover{
						text-decoration: none;
					}
				}
				li.active{
					background:#fff;
					font-weight: bold;
					font-size: 16px;
					color: #000;
					a{
						color: #000;
					}
				}
			}
		}
		.content{
			flex: 1;
			padding-left: 20px;
			background: #fff;
			border-radius: 12px;
			.empty{
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 260px;
				margin: 60px auto;
				img{
					width: 260px;
					height: 230px;
				}
				span{
					padding: 20px 0 30px;
					color: var(--color-text-opacity);
				}
				.public-btn{
					display: block;
					width: 88px;
					height: 34px;
					background: #DD0515;
					border-radius: 16px;
					line-height: 34px;
					text-align: center;
					color: #fff;
				}
			}
			/deep/ .el-tabs__active-bar{
				background-color: #DD0515;
			}
			/deep/ .el-tabs__item.is-active{
				color: #DD0515;
			}
			/deep/ .el-tabs__item:hover{
				color: #DD0515;
			}
		}
	}
</style>
